/* eslint-disable camelcase */
import { useMemo } from 'react';
import useUrlQuery from 'Hooks/useUrlQuery';

export function useAmazonSource() {
  const {
    mode, utm_source, src,
  } = useUrlQuery();

  const payload = useMemo(() => {
    const source = src ? src.toUpperCase() : 'GEN';

    const hasAmazonParams = utm_source?.toUpperCase() === 'AMZOON';

    const extSource = hasAmazonParams ? 'AMZ' : source;

    return {
      'ext-src': extSource,
      // ext-embedded: used to show a custom card in universal login
      ...(mode?.toUpperCase() === 'APP' && { 'ext-embedded': 'true' }),
    };
  }, [mode, utm_source, src]);

  return payload;
}
